/**
 * Peças do painel de conversa montadas no JS — o MESMO markup de `x-ds.conversa-mensagem` e `x-ds.conversa-passo`.
 *
 * Puro: nada aqui toca `document`/`window` ao carregar (só ao chamar), então o Node importa e testa
 * (`DsConversaContratoTest`, com um DOM mínimo). Texto da IA e da pessoa entra SEMPRE como texto (`textContent`,
 * `createTextNode`), nunca como HTML: é o que a tela recebe do servidor e o que a pessoa digitou.
 */
function icone(nome, tamanho = null) {
    const i = document.createElement('i');
    i.setAttribute('data-lucide', nome);
    i.setAttribute('aria-hidden', 'true');
    i.className = tamanho ? `ds-ico ds-ico--${tamanho}` : 'ds-ico';

    return i;
}

function elemento(tag, classe, texto = null) {
    const el = document.createElement(tag);
    el.className = classe;
    if (texto !== null) {
        el.textContent = String(texto);
    }

    return el;
}

function oculto(texto) {
    return elemento('span', 'visually-hidden', texto);
}

/** Uma mensagem, igual ao `x-ds.conversa-mensagem`. */
export function mensagem({ de = 'ia', rotulo = '', texto = '', digitando = false } = {}) {
    const quem = ['ia', 'pessoa', 'sistema'].includes(de) ? de : 'ia';
    if (quem === 'sistema') {
        return elemento('p', 'ds-conversa__sistema', texto ?? '');
    }
    const msg = elemento('div', `ds-conversa__msg ds-conversa__msg--${quem}`);
    if (rotulo) {
        const r = elemento('span', 'ds-conversa__rotulo');
        if (quem === 'ia') {
            r.appendChild(icone('sparkles', 'xs'));
        }
        r.appendChild(document.createTextNode(String(rotulo)));
        msg.appendChild(r);
    }
    const balao = elemento('p', 'ds-conversa__balao');
    if (digitando) {
        const pontos = elemento('span', 'ds-conversa__digitando');
        [0, 1, 2].forEach(() => pontos.appendChild(elemento('span', 'ds-conversa__ponto')));
        pontos.appendChild(oculto('digitando…'));
        balao.appendChild(pontos);
    } else {
        balao.textContent = String(texto ?? '');
    }
    msg.appendChild(balao);

    return msg;
}

/** Um passo do roteiro, igual ao `x-ds.conversa-passo`. */
export function passo({ numero = '', rotulo = '', estado = 'falta' } = {}) {
    const e = ['feito', 'agora', 'falta'].includes(estado) ? estado : 'falta';
    const li = elemento('li', `ds-conversa__passo ds-conversa__passo--${e}`);
    if (e === 'agora') {
        li.setAttribute('aria-current', 'step');
    }
    const num = elemento('span', 'ds-conversa__num', e === 'feito' ? null : numero);
    num.setAttribute('aria-hidden', 'true');
    if (e === 'feito') {
        num.appendChild(icone('check'));
    }
    li.append(num, document.createTextNode(String(rotulo)), oculto(`(${e})`));

    return li;
}
